export default __webpack_public_path__ + "media/components/Pages/Index/Images/abitur-a703d2ed4d402c9c3631b5e1c838512f.jpg";